import React from 'react';
import PropTypes from 'prop-types';
import { map, isEmpty } from 'lodash';
import { Button, Panel, ButtonGroup, Glyphicon } from 'react-bootstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { hiddenFields } from '../../../utils/report-builder';

const FieldButton = ({ field, onToggleField }) => {
  const onPressPivot = e => {
    e.stopPropagation();
    onToggleField(field, true);
  };
  return (
    <div
      className={classnames('tvt-report-builder__field-selector-field', {
        '--active': field.active
      })}
      onKeyDown={field.disabled ? null : () => onToggleField(field)}
      onClick={field.disabled ? null : () => onToggleField(field)}
      disabled={field.disabled}
    >
      {field.active && <Glyphicon glyph="ok" />}
      {field.label}
      {field.fieldType === 1 && (
        <Button
          onClick={field.disabled ? null : onPressPivot}
          className="field-button-pivot"
          active={field.activePivot}
        >
          {' '}
          pivot{' '}
        </Button>
      )}
      <Glyphicon glyph="minus-sign" />
    </div>
  );
};

const fieldType = PropTypes.shape({
  name: PropTypes.string,
  label: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool
});

FieldButton.propTypes = {
  field: fieldType,
  onToggleField: PropTypes.func
};

FieldButton.defaultProps = {
  field: {},
  onToggleField: () => {}
};

const FieldSelector = ({ fields, onToggleFieldGroup, ...rest }) => {
  if (isEmpty(fields)) return null;

  return (
    <div className="tvt-report-builder__field-selector">
      {map(fields, section => (
        <React.Fragment key={`field-selector--${section.name}`}>
          <Button
            className={classnames('tvt-report-builder__field-selector-button', {
              '--open': section.open
            })}
            onClick={() => onToggleFieldGroup(section.name)}
          >
            {section.label}
            {section.open ? (
              <FontAwesomeIcon
                className="tvt-report-builder__field-selector-caret-indicator"
                icon="angle-up"
                size="1x"
              />
            ) : (
              <FontAwesomeIcon
                className="tvt-report-builder__field-selector-caret-indicator"
                icon="angle-down"
                size="1x"
              />
            )}
          </Button>
          <Panel
            id="tvt-report-builder__field-selector"
            onToggle={() => {}}
            expanded={section.open}
          >
            <Panel.Collapse>
              <Panel.Body>
                <ButtonGroup vertical>
                  {map(section.fields, field =>
                    hiddenFields.includes(field.name) ? null : (
                      <FieldButton
                        key={`tvt-report-builder__selector-field-${section.name}-${field.name}`}
                        groupName={section.name}
                        field={field}
                        {...rest}
                      />
                    )
                  )}
                </ButtonGroup>
              </Panel.Body>
            </Panel.Collapse>
          </Panel>
        </React.Fragment>
      ))}
    </div>
  );
};

FieldSelector.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({})),
  onToggleFieldGroup: PropTypes.func
};

FieldSelector.defaultProps = {
  fields: {},
  onToggleFieldGroup: () => {}
};

export default FieldSelector;
